import { template, extend, clone, isObject, cloneDeep, range, toArray } from 'lodash';

function Components(systems) {

function Uuid() {
}
Uuid.__name = "uuid";
Uuid.create = function (ent) {
  if (ent.uuid) {
    throw new Error('already have uuid');
  }
  ent.addComponent(Uuid);
  ent.uuid.uuid = '' + ent.id;
  ent.uuid.parentTransform = null;
  ent.uuid.__transformId = null;
  ent.uuid.__extendedSlots = {};
  ent.uuid.__variableView = [];
  ent.uuid.__overrideTransforms = {};
  ent.uuid.__overrideVariables = {};
  ent.uuid.__internalVariables = {};
  ent.uuid.__destroyed = false;
  ent.uuid.__extendedSlots = null
  ent.uuid.__overrideLayer = null;
  ent.uuid.state = {};
  //ent.uuid.uuid = uuid.v4();
  return ent.uuid;
}

function LuaScript() {
}
LuaScript.__name = 'luaScript';
LuaScript.create = function (ent, component, root) {
  if (component.runOnRoot) {
    ent = root;
  }
  ent.addComponent(LuaScript);
  const fps = component.fps || 1;
  return {
    script: component.script,
    keep: component.keep || false,
    componentId: component.id,
    runOnRoot: component.runOnRoot || false,
    __toDestroy: false,
    __addComponents: false,
    started: false,
    internalVariables: [],
    timer: 1000 / parseFloat(fps),
    //ent.luaScript.timer = component.timer || (1000/30)
    currentTime: 0
  }
}

function AskInput() {
}
AskInput.__name = 'askInput';
AskInput.create = function (ent, component) {
  ent.addComponent(AskInput);
  ent.askInput.properties = component.properties;
  return ent.askInput;
}

function Log() {
}
Log.__name = 'log';
Log.create = function (ent, component) {
  ent.addComponent(Log);
  ent.log.statName = component.statName;
  ent.log.statValue = component.statValue;
  return ent.log;
}
function Leaderboard() {
}
Leaderboard.__name = 'leaderboard';
Leaderboard.create = function (ent, component) {
  ent.addComponent(Leaderboard);
  ent.leaderboard.category = component.category;
  ent.leaderboard.__addComponents = false;
  return ent.leaderboard;
}

function GiveScore() {
}
GiveScore.__name = 'giveScore';
GiveScore.create = function (ent, component) {
  ent.addComponent(GiveScore);
  ent.giveScore.score = component.score;
  ent.giveScore.id = component.id;
  return ent.giveScore;
}

function GameText() {
}
GameText.__name = 'gameText';
GameText.create = function (ent, text, zIndex, component) {
  ent.addComponent(GameText);
  ent.gameText.text = (text||'').trim();
  ent.gameText._templateFunc = template(ent.gameText.text, extend({},{
    interpolate:/{{([\s\S]+?)}}/g
  }));
  ent.gameText.templateFunc = function (props) {
    const formatted = {};
    Object.keys(props).forEach( (p) => {
      if (!isNaN(parseFloat(props[p]))) {
        const v = parseFloat(props[p]);
        if (Math.abs(v * 10 - Math.floor(v*10)) > 0) {
          formatted[p] = v.toFixed(2);
        } else if (Math.abs(v - Math.floor(v)) > 0) {
          formatted[p] = v.toFixed(1);
        } else {
          formatted[p] = v.toFixed(0);
        }
        //formatted[p] = Math.abs(v * 10 - Math.floor(v*10))
      } else {
        formatted[p] = props[p];
      }
    });
    return ent.gameText._templateFunc(formatted);
  }
  ent.gameText.zIndex = zIndex;
  ent.gameText.component = component;
  ent.gameText.wordWrapWidth = component.wordWrapWidth || 300;
  ent.gameText.__addComponents = false;
  if (!isNaN(parseInt(component.wordWrapWidth))) {
    ent.gameText.wordWrapWidth = parseInt(component.wordWrapWidth);
  }

  ent.gameText.bg = component.bg;
  ent.gameText.bgcolor = component.bgcolor;
  ent.gameText.bgx = component.bgx;
  ent.gameText.bgy = component.bgy;
  // if this is higher than 2, it flashes on restart.
  ent.gameText.__firstFrame = 1;
  ent.gameText.__setupBg = false;
  ent.gameText.bounded = component.bounded;
  ent.gameText.v = component.v;

  return ent.gameText;
}
function Slot() {
}
Slot.__name = 'slot';
Slot.create = function (ent, component) {
  ent.addComponent(Slot);
  return {
    component
  }
}

function Sequence() {
}
Sequence.__name = 'sequence';
Sequence.create = function (ent, ordering) {
  ent.addComponent(Sequence);
  return {
    ordering:[],
    current:0
  }
  ent.sequence.ordering = [];
  ent.sequence.current = 0;
  return ent.sequence;
}

function Camera() {
}
Camera.__name = 'camera';
Camera.create = function (ent, aspect, active, zoom) {
  ent.addComponent(Camera);
  ent.camera.aspect = aspect;
  ent.camera.active = active;
  ent.camera.zoom = zoom || 1;
  ent.camera.__addComponents = false;
  ent.camera.__addChildren = false;
  return ent.camera;
}

function TransformGraphCreate() {
}
TransformGraphCreate.__name = 'transformGraphCreate';
TransformGraphCreate.create = function (ent, transform) {
  ent.addComponent(TransformGraphCreate);
  ent.transformGraphCreate.transform = transform;
  return ent.transformGraphCreate;
}

function Transform() {
  this.x = 0;
  this.y = 0;
}
Transform.__name = "transform";
Transform.create = function (ent, transform, parentUuid=null,unparent=false, vars={}) {
  ent.addComponent(Transform);
  ent.transform.x = transform.transform.pos.x;
  ent.transform.y = transform.transform.pos.y;
  if (transform.transform.sendToOrigin) {
    ent.transform.x = 0;
    ent.transform.y = 0;
  }
  ent.transform.scale = clone(transform.transform.scale);
  ent.transform.rotation = transform.transform.rotation;
  ent.transform.zIndex = transform.transform.zIndex;
  if (isNaN(parseInt(ent.transform.zIndex))) {
    ent.transform.zIndex = 0;
  }
  ent.transform.layer = transform.transform.layer;
  ent.transform.anchorx = 0.5;
  ent.transform.anchory = 0.5;
  if (transform.transform.anchor) {
    ent.transform.anchorx = transform.transform.anchor.x;
    ent.transform.anchory = transform.transform.anchor.y;
  }
  ent.transform.dx = 0;
  ent.transform.dy = 0;
  ent.transform.localRotation = transform.transform.localRotation;
  ent.transform.localScale = clone(transform.transform.localScale);
  //ent.transform.transform = transform.transform;
  //ent.transform.children = transform.children;
  ent.transform.parentUuid = parentUuid;
  ent.transform.children = transform.children || [];
  ent.transform.unparent = unparent;
  ent.transform.inheritAngle = transform.transform.inheritAngle;
  ent.transform.disabled = transform.transform.disabled;
  if (typeof(transform.transform.alpha) === "undefined") {
    ent.transform.alpha = 1;
  } else {
    ent.transform.alpha = transform.transform.alpha;
  }
  ent.transform.visible = true;
  if (typeof(transform.transform.visible) !== 'undefined') {
    ent.transform.visible = transform.transform.visible;
  }
  ent.transform.unparent = transform.unparent || false;
  ent.transform.__children = [];
  ent.transform.variables = transform.variables || [];
  ent.transform.isDirty = 10;
  // should we read canvas position in beforeUpdatePhysicsBody
  ent.transform.__positionUpdated = false;
  // the special one that makes us read box2d position in 
  // afterUpdatePhysicsBody
  ent.transform.__positionUpdated2 = false;
  ent.transform.__lastX = -99999;
  ent.transform.__lastY = -999990;
  ent.transform.__lastRotation = -999;
  ent.transform.__lastScaleX = 99999999;
  ent.transform.__lastScaleY = 99999999;
  ent.transform.__lastLocalScaleX = 99999999;
  ent.transform.__lastLocalScaleY = 99999999;
  ent.transform.__lastAlpha = 99999999;
  /*
  ent.transform.x = parseFloat(x);
  ent.transform.y = parseFloat(y);
  ent.transform.scalex = parseFloat(scalex);
  ent.transform.scaley = parseFloat(scaley);
  ent.transform.anchorx = parseFloat(anchorx);
  ent.transform.anchory = parseFloat(anchory);
  ent.transform.rotation = parseFloat(0);
  ent.transform.dx = 0;
  ent.transform.dy = 0;
  ent.transform.alpha = 1;
  ent.transform.rotation = 0;
  */
  ent.transform.vars = vars;
  ent.transform.__worldPosition = null;
  return ent.transform;
}

function ApplyJoint() {
}
ApplyJoint.__name = 'applyjoint';
ApplyJoint.create = function (ent, jointType) {
  ent.addComponent(ApplyJoint);
  ent.applyjoint.jointType = jointType;
  return ent.applyjoint;
}
ApplyJoint.prototype.setData = function (data) {
  this.data = data;
  return this;
}
ApplyJoint.prototype.removeFunction = function (gameobjects, ent) {
}

function SetGameState() {
}
SetGameState.__name = "setGameState";
SetGameState.create = function (ent, state, message) {
    ent.addComponent(SetGameState);
    ent.setGameState.state = state;
    ent.setGameState.message = message || '';
    return ent.setGameState;
}

function SetState() {
}
SetState.__name = "setState";
SetState.create = function (ent, stateName, stateValue) {
  ent.addComponent(SetState);
  return {
    stateName,
    stateValue
  }
    ent.setState.stateName = stateName;
    ent.setState.stateValue = stateValue;
    return ent.setState;
}

function SpriteMask() {
}
SpriteMask.__name = 'spriteMask';
SpriteMask.create = function (ent, maskTransforms) {
  ent.addComponent(SpriteMask);
  ent.spriteMask.maskTransformIds = maskTransforms;
  return ent.spriteMask;
}

function Video() {
}
Video.__name = 'video';
Video.create = function (ent, texture, width, height, thumbnail) {
  ent.addComponent(Video);
  ent.video.texture = texture;
  ent.video.width = width;
  ent.video.height = height;
  ent.video.thumbnail = thumbnail;
  return ent.video;
}

function Sprite() {
}
Sprite.__name = "sprite";
Sprite.create = function (ent, texture, zIndex, atlas, isAtlas, ost, os, anims) {
  ent.addComponent(Sprite);
  ent.sprite.texture = texture;
  ent.sprite.zIndex = zIndex;
  ent.sprite.atlas = atlas;
  ent.sprite.isAtlas = isAtlas;
  ent.sprite.__addComponents = false;
  ent.sprite.ost = ost || false;
  ent.sprite.os = os ? {x:os.x,y:os.y} : null;
  ent.sprite.anims = anims;
  ent.sprite.firstFrame = 2;
  return ent.sprite;
}

function PlaySound() {
}
PlaySound.__name = "playSound";
PlaySound.create = function (ent, sound, loop) {
  ent.addComponent(PlaySound);
  ent.playSound.sound = sound;
  ent.playSound.loop = loop;
  ent.playSound.__soundStarted = false;
  return ent.playSound;
}

function ChangeBodyType() {
}
ChangeBodyType.__name = 'changebodytype';
ChangeBodyType.create = function (ent, bodyType) {
  ent.addComponent(ChangeBodyType);
  ent.changebodytype.bodyType = bodyType;
  return ent.changebodytype;
}

function PhysicsBody2D() {
}
PhysicsBody2D.__name = 'physicsbody2d';

PhysicsBody2D.create = function (ent, bodyType, sceneData, ignoreRotation, fixedRotation, density, friction, restitution, linearDamping, angularDamping, isSensor, shapeType, categoryBits, maskBits, groupIndex, componentId, scale, gravityScale, component) {
  ent.addComponent(PhysicsBody2D);
  ent.physicsbody2d.bodyType = bodyType;
  ent.physicsbody2d.sceneData = sceneData;
  ent.physicsbody2d.ignoreRotation = ignoreRotation;
  ent.physicsbody2d.fixedRotation = fixedRotation;
  ent.physicsbody2d.restitution = restitution;
  ent.physicsbody2d.linearDamping = linearDamping;
  ent.physicsbody2d.angularDamping = angularDamping;
  ent.physicsbody2d.density = density;
  ent.physicsbody2d.friction = friction;
  ent.physicsbody2d.isSensor = isSensor;
  ent.physicsbody2d.shapeType = shapeType;
  if (typeof(categoryBits) !== 'undefined') {
    ent.physicsbody2d.categoryBits = categoryBits;
  } else {
    ent.physicsbody2d.categoryBits = undefined;
  }
  if (typeof(maskBits) !== 'undefined') {
    ent.physicsbody2d.maskBits = maskBits;
  } else {
    ent.physicsbody2d.maskBits = undefined;
  }
  if (typeof(groupIndex) !== 'undefined') {
    ent.physicsbody2d.groupIndex = groupIndex;
  } else {
    ent.physicsbody2d.groupIndex = undefined;
  }
  ent.physicsbody2d.componentId = componentId;
  ent.physicsbody2d.scale = scale;
  ent.physicsbody2d.gravityScale = gravityScale;
  ent.physicsbody2d.scalex = parseFloat(component.scalex, 1) || 1;
  ent.physicsbody2d.scaley = parseFloat(component.scaley, 1) || 1;
  ent.physicsbody2d.tags = component.tags || '';
  ent.physicsbody2d.__addComponents = false;
  return ent.physicsbody2d;
}

function SetCollisionFilter() {
}
SetCollisionFilter.__name = 'setcollisionfilter';
SetCollisionFilter.create = function (ent, categoryBits, maskBits, groupIndex) {
  ent.addComponent(SetCollisionFilter);
  ent.setcollisionfilter.categoryBits = categoryBits;
  ent.setcollisionfilter.maskBits = maskBits;
  ent.setcollisionfilter.groupIndex = groupIndex;
  return ent.setcollisionfilter;
}

// Marker for physics bodies
function PhysicsBody() {
}
PhysicsBody.__name = 'physicsbody';

function PhysicsFixture() {
}
PhysicsFixture.__name = 'physicsfixture';

function FromToy() {
}
FromToy.__name = 'fromToy';

function PhysicsAddFixture() {
}
PhysicsAddFixture.__name = 'addfixture';
PhysicsAddFixture.create = function (ent, type) {
  ent.addComponent(PhysicsAddFixture);
  return ent.addfixture;
}


function RemoveJoints() {
}
RemoveJoints.__name = 'removejoints';
RemoveJoints.create = function (ent) {
  ent.addComponent(RemoveJoints);
  return ent.removejoints;
}

function ApplyImpulse2D() {
}
ApplyImpulse2D.__name = 'applyimpulse2d';
ApplyImpulse2D.create = function (ent, impulsex, impulsey, offsetx, offsety, keep) {
  ent.addComponent(ApplyImpulse2D);
  ent.applyimpulse2d.impulsex = impulsex;
  ent.applyimpulse2d.impulsey = impulsey;
  ent.applyimpulse2d.offsetx = offsetx;
  ent.applyimpulse2d.offsety = offsety;
  ent.applyimpulse2d.keep = keep;
  ent.applyimpulse2d.__addComponents = false;

  return ent.applyimpulse2d;
}

function SetLinearVelocity2d() {
}
SetLinearVelocity2d.__name = 'setlinearvelocity2d';
SetLinearVelocity2d.create = function (ent, component) {
  ent.addComponent(SetLinearVelocity2d);
  ent.setlinearvelocity2d.__addComponents = false;
  Object.assign(ent.setlinearvelocity2d, component);
  component.x = parseFloat(component.x);
  component.y = parseFloat(component.y);
  component.continous = component.continous || false;
  return ent.setlinearvelocity2d;
}

function SetBodyProperties() {
}
SetBodyProperties.__name = 'setbodyproperties';
SetBodyProperties.create = function (ent, component) {
  ent.addComponent(SetBodyProperties);
  Object.assign(ent.setbodyproperties, component);
  ent.setbodyproperties.density = parseFloat(component.density)
  ent.setbodyproperties.friction = parseFloat(component.friction)
  ent.setbodyproperties.restitution = parseFloat(component.restitution)
  return ent.setbodyproperties;
}


function ApplyForce2D() {
}
ApplyForce2D.__name = 'applyforce2d';
ApplyForce2D.create = function (ent, forcex, forcey, offsetx, offsety, maxVelocity, component) {
  ent.addComponent(ApplyForce2D);
  return {
    forcex:parseFloat(forcex),
    forcey:parseFloat(forcey),
    offsetx:parseFloat(offsetx),
    offsety:parseFloat(offsety),
    __addComponents:false,
    maxVelocity:parseFloat(maxVelocity),
    keep: component.keep,
    time: parseFloat(component.time || 1),
    t:0
  }
  ent.applyforce2d.forcex = parseFloat(forcex);
  ent.applyforce2d.forcey = parseFloat(forcey);
  ent.applyforce2d.offsetx = parseFloat(offsetx);
  ent.applyforce2d.offsety = parseFloat(offsety);
  ent.applyforce2d.offsety = parseFloat(offsety);
  ent.applyforce2d.maxVelocity = parseFloat(maxVelocity);
  return ent.applyforce2d;
}

function AnimatedSprite() {
}
AnimatedSprite.__name = "animatedSprite";
AnimatedSprite.create = function (ent, prefix, numFrames, speed, anchorx, anchory, scalex, scaley, zIndex) {
  ent.addComponent(AnimatedSprite);
    ent.animatedSprite.anchorx = anchorx;
    ent.animatedSprite.anchory = anchory;
    ent.animatedSprite.scalex = scalex;
    ent.animatedSprite.scaley = scaley;
    ent.animatedSprite.zIndex = zIndex;
    ent.animatedSprite.numFrames = numFrames;
    ent.animatedSprite.speed = speed;
    ent.animatedSprite.prefix = prefix;
  return ent.animatedSprite;
}

function TiledSprite() {
}
TiledSprite.__name = "tiledSprite";
TiledSprite.create = function (ent, texture, zIndex, atlas, isAtlas, sizex, sizey, basesizex, basesizey, component) {
  ent.addComponent(TiledSprite);
  ent.tiledSprite.texture = texture;
  ent.tiledSprite.atlas = atlas;
  ent.tiledSprite.isAtlas = isAtlas;
  ent.tiledSprite.zIndex = zIndex;
  ent.tiledSprite.originalX = ent.transform.x;
  ent.tiledSprite.originalY = ent.transform.y;
  ent.tiledSprite.sizex = parseFloat(sizex);
  ent.tiledSprite.sizey = parseFloat(sizey);
  ent.tiledSprite.basesizex = parseFloat(basesizex);
  ent.tiledSprite.basesizey = parseFloat(basesizey);
  ent.tiledSprite.offsetx = parseFloat(component.offsetx);
  ent.tiledSprite.offsety = parseFloat(component.offsety);
  ent.tiledSprite.lockToCamera = component.lockToCamera;
  ent.tiledSprite.parallaxx = parseFloat(component.parallaxx);
  ent.tiledSprite.parallaxy = parseFloat(component.parallaxy);
  return ent.tiledSprite;
}


function AutoMove() {
}
AutoMove.__name = "autoMove";
AutoMove.create = function (ent, dx, dy, respectRotation) {
  ent.addComponent(AutoMove);
  const automove = {
    dx: !isObject(dx) ? parseFloat(dx) : dx,
    dy: !isObject(dy) ? parseFloat(dy) : dy,
    respectRotation: respectRotation || false,
    __addComponents: false
  }
  return automove;
}

function RemoveComponentFromToy() {
}
RemoveComponentFromToy.__name = 'removeComponentFromToy';
RemoveComponentFromToy.create = function (ent, component) {
  ent.addComponent(RemoveComponentFromToy);
  return {
    component:component
  }
  ent.removeComponentFromToy.component = component;
  return ent.removeComponentFromToy;
}
function Repeater() {
}
Repeater.__name = "repeater";
Repeater.create = function (ent, tid, firetime, initialDelay, probability, times) {

  //firetime = systems.getScalar(ent, firetime);
  //initialDelay = systems.getScalar(ent, initialDelay);
  //probability = systems.getScalar(ent, probability);
  //times = system.getScalar(ent, times);

  ent.addComponent(Repeater);
  ent.repeater.__addComponents = false;
  return {
    firetime,
    initialDelay,
    tid,
    curTime:0,
    activated:false,
    probability,
    times,
    timesFired:0
  }
}

function Spawner() {
}
Spawner.__name = "spawner";
Spawner.create = function (ent) {
  ent.addComponent(Spawner);
  ent.spawner.__addComponents = false;

  //firetime = systems.getScalar(ent, firetime);
  //initialDelay = systems.getScalar(ent, initialDelay);
  //probability = systems.getScalar(ent, probability);
  //times = system.getScalar(ent, times);

  return {
    __addComponents:false,
    spawners:{},
    activated: false
  }
}
function RandomMover() {
}
RandomMover.__name = "randomMover";
RandomMover.create = function (ent, xrange, yrange, xinc, yinc) {
  ent.addComponent(RandomMover);
  ent.randomMover.xrange = xrange;
  ent.randomMover.yrange = yrange;
  ent.randomMover.xinc = xinc;
  ent.randomMover.yinc = yinc;
  return ent.randomMover;
}
function CollisionBox() {
}
CollisionBox.__name = "collisionBox";
CollisionBox.create = function (ent, scalex, scaley, tag) {
  ent.addComponent(CollisionBox);
  return {
    tag,
    scalex:parseFloat(scalex),
    scaley:parseFloat(scaley),
  }
  const transform = ent.transform;
  ent.collisionBox.entuuid = ent.uuid.uuid;
  ent.collisionBox.scalex = parseFloat(scalex);
  ent.collisionBox.scaley = parseFloat(scaley);
  ent.collisionBox.lastx = 99999999;
  ent.collisionBox.lasty = 99999999;
  ent.collisionBox.lastScale = {
    x:9999999,
    y:9999999,
  }
  ent.collisionBox.tag = tag;
  return ent.collisionBox;
}
CollisionBox.prototype.removeFunction = function (gameobjects, component, ent) {
  ent.removeTag(component.tag);
}



function Destroy() {
}
Destroy.__name = "destroy";
Destroy.create = function (ent) {
  ent.addComponent(Destroy);
  return ent.destroy;
}
function Properties() {
    this.properties = {};
    this.name = 'Unnamed';
}
Properties.__name = "properties";
Properties.create = function (ent, name) {
    ent.addComponent(Properties);
    ent.addTag(name);
    ent.properties.name = name;
    return ent.properties;
}
function SetProperties() {
}
SetProperties.__name = "setProperties";
SetProperties.create = function (ent, o) {
  ent.addComponent(SetProperties);
  const params = {};
  o.forEach( (p) => {
      params[p.name] = p.value;
  } );
  return {
    properties:params
  }
}
function ChangeProperties() {
}
ChangeProperties.__name = "changeProperties";
ChangeProperties.create = function (ent, o) {
  ent.addComponent(ChangeProperties);
  const params = {};
  o.forEach( (p) => {
      params[p.name] = p.value;
  } );
  return {
    properties:params
  }
}
function LimitProperties() {
}
LimitProperties.__name = "limitProperties";
LimitProperties.create = function (ent, component) {
  ent.addComponent(LimitProperties);
  return {
    properties:clone(component.properties)
  }
}

function CollisionLayers() {
}
CollisionLayers.__name = "collisionLayers";
CollisionLayers.create = function (ent, layerA, layerB) {
  ent.addComponent(CollisionLayers);
  return {
    layerA,
    layerB
  }
    ent.collisionLayers.layerA = layerA;
    ent.collisionLayers.layerB = layerB;
    return ent.collisionLayers;
}
function CollisionWith() {
}
CollisionWith.__name = "collisionWith";
CollisionWith.create = function (ent, tags, onceOnly, onceOnlyTag, specialTags) {
  ent.addComponent(CollisionWith);
  if (specialTags) {
    tags = tags.concat(specialTags.split(","));
  }
  return {
    tags,
    onceOnly,
    onceOnlyTag,
    specialTags,
    alreadyCollided:{}
  }
    ent.collisionWith.tag = tag;
    ent.collisionWith.onceOnly = onceOnly;
    ent.collisionWith.onceOnlyTag = onceOnly;
    ent.collisionWith.alreadyCollided = {};
    return ent.collisionWith;
}

function Goal() {
}
Goal.__name = "goal";
Goal.create = function (ent, win, lose) {
    ent.addComponent(Goal);
    ent.goal.win = win;
    ent.goal.lose = lose;
    return ent.goal;
}

function CreateToy() {
}
CreateToy.__name = 'createToy';
CreateToy.create = function (ent, component) {
  ent.addComponent(CreateToy);
  ent.createToy.__addComponents = false;
  return {
    component,
    unparent:typeof(component.unparent) !== "undefined" ? component.unparent : true,
    //unparent:true,
    translatex:parseFloat(component.translatex || 0),
    translatey:parseFloat(component.translatey || 0),
  }
}
function CreateFeature() {
}
CreateFeature.__name = 'createFeature';
CreateFeature.create = function (ent, component) {
  ent.addComponent(CreateFeature);
  return {
    component,
    fid:component.fid,
    builtin:component.builtin
  }
  ent.createFeature.component = component;
  return ent.createFeature;
}

function CreateEntity() {
}
CreateEntity.__name = "createEntity";
CreateEntity.create = function (ent, component, overrideTransform, data, translatex, translatey) {
  ent.addComponent(CreateEntity);
  let o ={
    component,
    overrideTransform,
    //scalex:parseFloat(data.scale.x),
    //scaley:parseFloat(data.scale.y),
    translatex:translatex || 0,
    translatey:translatey || 0
  }
  if (overrideTransform) {
    o.scalex = parseFloat(data.scale.x);
    o.scaley = parseFloat(data.scale.y);
  }
  return o;
  ent.createEntity.component = component;
  ent.createEntity.overrideTransform = overrideTransform;
  if (ent.createEntity.overrideTransform) {
    ent.createEntity.scalex = parseFloat(data.scale.x);
    ent.createEntity.scaley = parseFloat(data.scale.y);
  }
  ent.createEntity.translatex = translatex || 0;
  ent.createEntity.translatey = translatey || 0;
  return ent.createEntity;
}

function Tween() {
}
Tween.__name = "tween";

Tween.create = function (ent, time, tweens, loop, flip, startDelay, v2, reset, loopDelay, flipDelay) {
  function numberOrZero(n) {
    if (typeof(n) === 'undefined') {
      return 0;
    }
    return parseFloat(n);
  }
  ent.addComponent(Tween);

  time = systems.getScalar(ent, time);
  startDelay = systems.getScalar(ent, startDelay);
  if (isNaN(startDelay)) {
    startDelay = 0
  }
  return {
    t:0,
    time:parseFloat(time),
    loop,
    loopDelay:numberOrZero(loopDelay),
    flipDelay:numberOrZero(flipDelay),
    flip,
    started:false,
    startedAfterDelay:false,
    startDelayTime:0,
    startDelay,
    finished:false,
    direction:'forward',
    v2,
    reset,
    tweens:tweens.map( (x) => {
      x = cloneDeep(x);
      x.from = systems.getScalar(ent, x.from);
      x.to = systems.getScalar(ent, x.to);
      return x;
    }),
    removeFunction:(systems, gameobjects, instance, ent) => {
      if (!instance.finished && instance.reset) {
        instance.finished = true;
        systems.updateTween(1000/60.0, ent);
      }
    }
  }

}

function Point() {
}
Point.__name = 'point';
Point.create = function (ent, component) {
  ent.addComponent(Point);
  return ent.point;
}
function Path() {
}
Path.__name = 'path';
Path.create = function (ent, component) {
  ent.addComponent(Path);
  ent.path.points = component.points;
  ent.path.__addComponents = false;
  ent.path.edges = range(component.edges.length).map( (i) => {
    const edge = component.edges[i];
    const p1 = component.points[i];
    const p2 = component.points[ (i+1) % component.points.length ];
    return {
      p1,
      p2,
      cps:edge.cps,
      type:edge.type,
      original:edge
    }
  });
  ent.path.componentId = component.id;
  return ent.path
}

function MoveTo() {
}
MoveTo.__name = "moveTo";
MoveTo.create = function (ent, component) {
    ent.addComponent(MoveTo);
    ent.moveTo.pathId = component.pathId;
    ent.moveTo.t = 0;
    ent.moveTo.curCurve = 0;
    ent.moveTo.started = false;
    ent.moveTo.flip = component.flip;
    ent.moveTo.direction = 'forward';
    ent.moveTo.speed = parseFloat(component.speed) || 1;
    ent.moveTo.tween = component.tween;
    ent.moveTo.changeAngle = component.changeAngle;
    ent.moveTo.offsetAngle = parseFloat(component.offsetAngle);
    ent.moveTo.startGlobal = {};
    ent.moveTo.endGlobal = {}
    ent.moveTo.diffGlobal = {};
    ent.moveTo.thePointEnt = null;
    ent.moveTo.follow = component.follow;

    return ent.moveTo;
}

function FollowPath() {
}
FollowPath.__name = "followPath";
FollowPath.create = function (ent, pathId, flip, speed, tween, changeAngle, offsetAngle) {
    ent.addComponent(FollowPath);
    ent.followPath.pathId = pathId;
    ent.followPath.t = 0;
    ent.followPath.curCurve = 0;
    ent.followPath.started = false;
    ent.followPath.flip = flip;
    ent.followPath.direction = 'forward';
    ent.followPath.speed = parseFloat(speed) || 1;
    ent.followPath.tween = tween;
    ent.followPath.changeAngle = changeAngle;
    ent.followPath.offsetAngle = parseFloat(offsetAngle);
    return ent.followPath;
}

function TapController() {
}
TapController.__name = "tapController";
TapController.create = function (ent, tapAnywhere, repeatEnabled, cooldown, cooldownEvent, cooldownKey, component) {
  ent.addComponent(TapController);
  return {
    tapAnywhere,
    repeatEnabled,
    cooldown:parseFloat(cooldown),
    cooldownKey,
    cooldownEvent,
    lastTap:0,
    scalex:parseFloat(component.scalex || 1),
    scaley:parseFloat(component.scaley || 1),
    addedBusy:[]
  }
}

function PressController() {
}
PressController.__name = "pressController";
PressController.create = function (ent, horizontalMargin, verticalMargin, useTap) {
    ent.addComponent(PressController);
    ent.pressController.horizontalMargin = horizontalMargin;
    ent.pressController.verticalMargin = verticalMargin;
    ent.pressController.useTap = useTap;
    return ent.pressController;
}

function PanController() {
}
PanController.__name = "panController";
PanController.create = function (ent, component) {
    ent.addComponent(PanController);
    ent.panController.lerpx = component.lerpx;
    ent.panController.lerpy = component.lerpy;
    ent.panController.velocity = component.velocity;
    ent.panController.rotation = component.rotation || {};
    ent.panController.startX = component.startX;
    ent.panController.startY = component.startY;
    ent.panController.endX = component.endX;
    ent.panController.endY = component.endY;
    ent.panController.x = component.x;
    ent.panController.y = component.y;
    ent.panController.length = component.length;
    ent.panController.prevRotation = component.prevRotation;
    return ent.panController;
}


function KeyController() {
}
KeyController.__name = "keyController";
KeyController.create = function (ent, keymap) {
    ent.addComponent(KeyController);
    ent.keyController.slots = null;
    return ent.keyController;
}


function Jump() {
}
Jump.__name = "jump";
Jump.create = function (ent, dx, dy, platformTag) {
    ent.addComponent(Jump);
    ent.jump.dx = dx !== '' ? parseFloat(dx) : undefined;
    ent.jump.dy = dy !== '' ? parseFloat(dy) : undefined;
    if (platformTag) {
      ent.jump.platformTags = platformTag.split(",");
    } else {
      ent.jump.platformTags = [];
    }
    ent.jump.__addComponents = false;
    return ent.jump;
}
function GravityAffected() {
  this.gravity = 10;
}
GravityAffected.__name = "gravityAffected";
GravityAffected.create = function (ent, gravity) {
  ent.addComponent(GravityAffected);
  ent.gravityAffected.originalX = ent.transform.x;
  ent.gravityAffected.originalY = ent.transform.y;
  ent.gravityAffected.gravity = gravity;
  return ent.gravityAffected;
}

function Random() {
}
Random.__name = "random";
Random.create = function (ent, probability) {
  ent.addComponent(Random);
  ent.random.probability = probability;
  return ent.random;
}

function RandomChoose() {
}
RandomChoose.__name = "randomChoose";
RandomChoose.create = function (ent, components) {
    ent.addComponent(RandomChoose);
    ent.randomChoose.__addComponents = false;
    return ent.randomChoose;
}

function Move() {
}
Move.__name = "move";
Move.create = function (ent, dx, dy, dscale, t, tween) {
    ent.addComponent(Move);
    const newMove = {};
    newMove.dx = parseFloat(systems.getScalar(ent, dx));
    newMove.dy = parseFloat(systems.getScalar(ent, dy));
    newMove.dscale = parseFloat(systems.getScalar(ent, dscale));
    newMove.t = 0;
    newMove.tween = tween;
    newMove.speed = parseFloat(systems.getScalar(ent, t));
    newMove.startx = parseFloat(ent.transform.x);
    newMove.starty = parseFloat(ent.transform.y);
    newMove.startscalex = parseFloat(ent.transform.scalex);
    newMove.startscaley = parseFloat(ent.transform.scaley);
    newMove.prevx = 0;
    newMove.prevy = 0;

    return newMove;
}

function SwipeController() {
}
SwipeController.__name = "swipeController";
SwipeController.create = function (ent, component) {
    ent.addComponent(SwipeController);
    ent.swipeController.lerpx = component.lerpx;
    ent.swipeController.lerpy = component.lerpy;
    ent.swipeController.velocity = component.velocity;
    return ent.swipeController;
}

function StopMovement() {
}
StopMovement.__name = "stopMovement";
StopMovement.create = function (ent, revertToStart) {
    ent.addComponent(StopMovement);
    ent.stopMovement.revertToStart = revertToStart;
    return ent.stopMovement;
}

function Circle() {
}
Circle.__name = 'circle';
Circle.create = function (ent, cx, cy, radius, startAngle, endAngle, color, lineColor, lineWidth, outline, fill) {
  ent.addComponent(Circle);
  ent.circle.cx = cx;
  ent.circle.cy = cy;
  ent.circle.radius = radius;
  ent.circle.startAngle = startAngle;
  ent.circle.endAngle = endAngle;
  ent.circle.color = color;
  ent.circle.lineColor = lineColor;
  ent.circle.lineWidth = lineWidth;
  ent.circle.outline = outline;
  ent.circle.fill = fill;
  return ent.circle;
}

function Shape() {
}
Shape.__name = "shape";
Shape.create = function (ent, type, color, zIndex, stroke, scalex, scaley, lineWidth=0.05, dontCacheAsBitmap=false, theme) {
    ent.addComponent(Shape);
    ent.shape.type = type;
    ent.shape.shapetype = type;
    ent.shape.color = color;
    ent.shape.zIndex = zIndex;
    ent.shape.stroke = stroke;
    ent.shape.__addComponents = false;
    ent.shape.scalex = parseFloat(typeof(scalex) !== 'undefined' ? scalex: 1);
    ent.shape.scaley = parseFloat(typeof(scaley) !== 'undefined' ? scaley: 1);
    ent.shape.lineWidth = parseFloat(lineWidth)
    ent.shape.dontCacheAsBitmap = dontCacheAsBitmap;
    ent.shape.theme = theme;
    ent.shape.firstFrame = 2;
    return ent.shape;
}

function Cooldown() {
}
Cooldown.__name = "cooldown";
Cooldown.create = function (ent, cooldown, cooldownEvent, cooldownKey) {
  ent.addComponent(Cooldown);
  return {
    cooldown,
    cooldownEvent,
    cooldownKey,
    curtime:0
  }
  return ent.cooldown;
}

function Delay() {
}
Delay.__name = "delay";
Delay.create = function (ent, delay) {
  ent.addComponent(Delay);
  return {
    curtime:0,
    delay:parseFloat(delay)
  }
  ent.delay.delay = parseFloat(delay);
  ent.delay.curtime = 0;
  return ent.delay;
}
function DelayTransform() {
}
DelayTransform.__name = "delayTransform";
DelayTransform.create = function (ent, component) {
  ent.addComponent(DelayTransform);
  ent.delayTransform.curtime = 0;
  ent.delayTransform.spawned = [];
  ent.delayTransform.__addComponents = false;
  return ent.delayTransform;
}
function RandomTransform() {
}
RandomTransform.__name = "randomTransform";
RandomTransform.create = function (ent, component) {
  ent.addComponent(RandomTransform);
  ent.randomTransform.__addComponents = false;
  return ent.randomTransform;
}
function OnEventTransform() {
}
OnEventTransform.__name = "onEventTransform";
OnEventTransform.create = function (ent, component) {
  ent.addComponent(OnEventTransform);
  ent.onEventTransform.eventName = component.eventName;
  ent.onEventTransform.__addComponents = false;
  return ent.onEventTransform;
}
function ParallaxTransform() {
}
ParallaxTransform.__name = "parallaxTransform";
ParallaxTransform.create = function (ent, component) {
  ent.addComponent(ParallaxTransform);
  ent.parallaxTransform.px = parseFloat(component.px);
  ent.parallaxTransform.py = parseFloat(component.py);
  return ent.parallaxTransform;
}

class MultiComponent {
  constructor(componentType, component, args, unique=false) {
    this.componentType = componentType;
    this.component = component;
    this.args = args;
    this.__name = componentType.__name;
    this.unique = unique;
    this.running = {};
    this.multi = [];

  }

  create(ent) {
    if (!ent[this.__name]) {
      //ent.addComponent(this.componentType);
      const o = this.componentType.create.apply(this.componentType, toArray(arguments));
        //c:cloneDeep(o),
      const c = o;
      ent[this.__name].multi = [{
        c,
        component:this.component,
        componentType:this.componentType
      }];
      ent[this.__name].running = {};
      ent[this.__name].running[this.component.id] = true;

      return o;

    } else {
      const o = this.componentType.create.apply(this.componentType, toArray(arguments));
      const c = o;
      if (this.unique) {
        //const thisComponent = ent[this.__name].multi.filter( (multi) => {
          //return multi.component.id === this.component.id;
        //});
        if (ent[this.__name].running[this.component.id]) {
          // ignore
        } else {
          ent[this.__name].running[this.component.id] = true;
          ent[this.__name].multi.push({
            c,
            component:this.component,
            componentType:this.componentType
          });
        }
      } else {
        ent[this.__name].running[this.component.id] = true;
        ent[this.__name].multi.push({
          c,
          component:this.component,
          componentType:this.componentType
        });
      }
      return o;
    }
    return this;
  }
}

function Target() {
}
Target.__name = "target";
Target.create = function (ent, targetName) {
  ent.addComponent(Target);
  ent.target.targetName = targetName;
  return ent.target;
}

function Multiple() {
}
Multiple.__name = "multiple";
Multiple.create = function (ent) {
  ent.addComponent(Multiple);
  return {
    done:false,
    added:[],
    removeFunction: (systems, gameobjects, instance, ent) => {
      if (!instance.keep) {
        return;
      }
      console.log('remove multiple!!!!', instance);
      for (let i = instance.added.length - 1; i >= 0; i--) {
        const c = instance.added[i];
        console.log('remove..................', c);
        systems.removeComponentManually(ent, c);
      }
    }
  }
  ent.multiple.added = [];
  return ent.multiple;
}
Multiple.removeFunction = function (systems, gameobjects, component, ent) {
  return;
}


function Translate() {
}
Translate.__name = "translate";
Translate.create = function (ent, dx, dy, dr, dsx, dsy, translateType, keep, lerpt) {
  ent.addComponent(Translate);
  return {
    dx: dx,
    dy: dy,
    dr: dr,
    dsx: dsx,
    dsy: dsy,
    translateType: translateType,
    keep: keep,
    lerpt,
    __addComponents: false
  }
}
Translate.setData = function (data) {
}

function EmitEvent() {
}
EmitEvent.__name = "emitEvent";
EmitEvent.create = function (ent, eventName, localEvent) {
  ent.addComponent(EmitEvent);
  return {
    eventName,
    localEvent
  }
  ent.emitEvent.eventName = eventName;
  ent.emitEvent.localEvent = localEvent;
  return ent.emitEvent;
}

function OnEvent() {
}
OnEvent.__name = "onEvent";
OnEvent.create = function (ent, eventName, onceOnly) {
  ent.addComponent(OnEvent);
  return {
    eventName,
    onceOnly
  }
  ent.onEvent.eventName = eventName;
  ent.onEvent.onceOnly = onceOnly;
  return ent.onEvent;
}

function OnDestroy() {
}
OnDestroy.__name = "onDestroy";
OnDestroy.create = function (ent) {
  ent.addComponent(OnDestroy);
  ent.onDestroy.triggered = false;
  ent.onDestroy.activated = false;
  return ent.onDestroy;

}

function RestrictPosition() {
}
RestrictPosition.__name = "restrictPosition";
RestrictPosition.create = function (ent, minX, minY, maxX, maxY) {
  ent.addComponent(RestrictPosition);
  ent.restrictPosition.minX = parseFloat(minX);
  ent.restrictPosition.maxX = parseFloat(maxX);
  ent.restrictPosition.minY = parseFloat(minY);
  ent.restrictPosition.maxY = parseFloat(maxY);
  return ent.restrictPosition;
}
function MoveHere() {
}
MoveHere.__name = 'moveHere';
MoveHere.create = function (ent, tag, speed, tween) {
  ent.addComponent(MoveHere);
  ent.moveHere.tag = tag;
  ent.moveHere.speed = parseFloat(speed);
  ent.moveHere.tween = tween;
  return ent.moveHere;
}

function TileMap() {
}
TileMap.__name = 'tileMap';
TileMap.create = function (ent, map) {
  ent.addComponent(TileMap);
  ent.tileMap.tiled = map.tiled;
  return ent.tileMap;
}
function GotoScene() {
}
GotoScene.__name = 'gotoScene';
GotoScene.create = function (ent, component) {
  ent.addComponent(GotoScene);
  ent.gotoScene.scene = component.scene;
  ent.gotoScene.ignore = component.ignore;
  ent.gotoScene.mode = component.mode || 'specific';
  ent.gotoScene.skipFrames = typeof(component.skipFrames) !== 'undefined' ? component.skipFrames : 3;
  return ent.gotoScene;
}

function GotoGame() {
}
GotoGame.__name = 'gotoGame';
GotoGame.create = function (ent, component) {
  ent.addComponent(GotoGame);
  ent.gotoGame.gameId = component.gameId;
  return ent.gotoGame;
}


function FetchTransform() {
}
FetchTransform.__name = 'fetchTransform';
FetchTransform.create = function (ent, component) {
  ent.addComponent(FetchTransform);
  ent.fetchTransform.url = component.url;
  ent.fetchTransform.script = component.script;
  ent.fetchTransform.state = '';
  ent.fetchTransform.queryData = component.data || [];
  ent.fetchTransform.__addComponents = false;
  ent.fetchTransform.startEvent = component.startEvent || 'startFetchData';
  ent.fetchTransform.endEvent = component.endEvent || 'endFetchData';
  ent.fetchTransform.errorEvent = component.errorEvent || 'endFetchData';
  ent.fetchTransform.method = component.method || 'GET';
  ent.fetchTransform.sendAsBody = component.sendAsBody || false;
  return ent.fetchTransform;
}
function FetchData() {
}
FetchData.__name = 'fetchData';
FetchData.create = function (ent, component) {
  ent.addComponent(FetchData);
  ent.fetchData.url = component.url;
  ent.fetchData.script = component.script;
  ent.fetchData.data = component.data;
  ent.fetchData.state = '';
  ent.fetchData.__addComponents = false;
  ent.fetchData.startEvent = component.startEvent || 'startFetchData';
  ent.fetchData.endEvent = component.endEvent || 'endFetchData';
  ent.fetchData.errorEvent = component.errorEvent || 'endFetchData';
  ent.fetchData.method = component.method || 'POST';
  ent.fetchData.sendAsBody = typeof(component.sendAsBody) !== 'undefined' ? component.sendAsBody : true;
  return ent.fetchData;
}
function StateManager() {
}
StateManager.__name = 'stateManager';
StateManager.create = function (ent, component) {
  ent.addComponent(StateManager);
  ent.stateManager.stateVariable = component.stateVariable;
  ent.stateManager.state = '';
  ent.stateManager.prevState = '';
  ent.stateManager.prevChildren = [];
  ent.stateManager.__addComponents = false;
  return ent.stateManager;
}
function StateManagerFeature() {
}
StateManagerFeature.__name = 'stateManagerFeature';
StateManagerFeature.create = function (ent, component) {
  ent.addComponent(StateManagerFeature);
  return {
    stateVariable: component.stateVariable,
    state: '',
    prevState: '',
    prevComponents: [],
    __addComponents: false
  }
}

function GroupTransform() {
}
GroupTransform.__name = 'groupTransform';
GroupTransform.create = function (ent, component) {
  ent.addComponent(GroupTransform);
  ent.groupTransform.sendToOrigin = component.sendToOrigin;
  ent.groupTransform.__addComponents = false;
  return ent.groupTransform;
}

function AllTransforms() {
}
AllTransforms.__name = 'allTransforms';
AllTransforms.create = function (ent, component) {
  ent.addComponent(AllTransforms);
  ent.allTransforms.ignore = (component.ignore||'').split(",");
  ent.allTransforms.__addComponents = false;
  return ent.allTransforms;
}
function SetTransformProperties() {
}
SetTransformProperties.__name = 'setTransformProperties';
SetTransformProperties.create = function (ent, component) {
  ent.addComponent(SetTransformProperties);
  ent.setTransformProperties.visible = component.visible;
  return ent.setTransformProperties;
}

function StartScene() {
}
StartScene.__name = 'startScene';
StartScene.create = function (ent, scene, oldEnts = []) {
  ent.addComponent(StartScene);
  ent.startScene.scene = scene;
  ent.startScene.oldEnts = oldEnts;
  return ent.startScene;
}

function ConditionalTransform() {
}
ConditionalTransform.__name = 'conditionalTransform';
ConditionalTransform.create = function (ent, component) {
  ent.addComponent(ConditionalTransform);
  ent.conditionalTransform.script = component.script;
  ent.conditionalTransform.evaluated = false;
  ent.conditionalTransform.componentId = component.id;
  ent.conditionalTransform.__addComponents = false;
  return ent.conditionalTransform;
}
function ForEachTransform() {
}
ForEachTransform.__name = 'forEachTransform';
ForEachTransform.create = function (ent, component) {
  ent.addComponent(ForEachTransform);
  ent.forEachTransform.script = component.script;
  ent.forEachTransform.xSpacing = component.xSpacing;
  ent.forEachTransform.ySpacing = component.ySpacing;
  ent.forEachTransform.__addComponents = false;
  return ent.forEachTransform;
}
function ParticleTransform() {
}
ParticleTransform.__name = 'particleTransform';
ParticleTransform.create = function (ent, component) {
  ent.addComponent(ParticleTransform);
  ent.particleTransform.component = component;
  ent.particleTransform.__addComponents = false;
  return ent.particleTransform;
}
function SpineTransform() {
}
SpineTransform.__name = 'spineTransform';
SpineTransform.create = function (ent, component) {
  ent.addComponent(SpineTransform);
  ent.spineTransform.spine = component.spine;
  ent.spineTransform.attachments = []
  return ent.spineTransform;
}

function SpineControl() {
}
SpineControl.__name = 'spineControl';
SpineControl.create = function (ent, component) {
  ent.addComponent(SpineControl);
  return {
    action:component.action,
    data:Object.assign({},component)
  }
}

function GridTransform() {
}
GridTransform.__name = 'gridTransform';
GridTransform.create = function (ent, component) {
  ent.addComponent(GridTransform);
  ent.gridTransform.component = component;
  ent.gridTransform.__addComponents = false;
  return ent.gridTransform;
}

function Timeline() {
}
Timeline.__name = 'timeline';
Timeline.start = function (ent, name) {
  if (!ent.timeline.timelines[name]) {
    ent.timeline.timelines[name] = {
      name,
      prevT:-1,
      t:0
    }
  }
}

Timeline.create = function (ent, component) {
  if (!ent.timeline) {
    ent.addComponent(Timeline);
    ent.timeline.timelines = {};
  }
  Timeline.start(ent, component.name);
  return ent.timeline;
}
function StartTimeline() {
}
StartTimeline.__name = 'startTimeline';
StartTimeline.create = function (ent, component) {
  ent.addComponent(StartTimeline);
  return {
    name:component.timelineName,
    localTimeline:component.localTimeline
  }
  ent.startTimeline.name = component.timelineName;
  ent.startTimeline.localTimeline = component.localTimeline;
  return ent.startTimeline;
}

function OnTimeline() {
}
OnTimeline.__name = 'onTimeline'
OnTimeline.create = function (ent, component) {
  ent.addComponent(OnTimeline);
  return {
    name:component.timelineName,
    time:component.time,
    onTimes:null
  }
  ent.onTimeline.name = component.timelineName;
  ent.onTimeline.time = component.time;
  ent.onTimeline.onTimes = null;
  return ent.onTimeline;
}

function ScrollTransform() {
}
ScrollTransform.__name = 'scrollTransform'
ScrollTransform.create = function (ent, component) {
  ent.addComponent(ScrollTransform);
  return ent.scrollTransform;
}

function Unparent() {
}
Unparent.__name = 'unparent';
Unparent.create = function (ent) {
  ent.addComponent(Unparent);
  return ent.unparent;
}

function CameraFollows() {
}
CameraFollows.__name = 'cameraFollows';
CameraFollows.create = function (ent) {
  ent.addComponent(CameraFollows);
  return ent.cameraFollows;
}

function PlayAnimation() {
}
PlayAnimation.__name = 'playAnimation';
PlayAnimation.create = function (ent, animationName, loop, speedMultiplier) {
  ent.addComponent(PlayAnimation);
  return ent.playAnimation;
}

return {
  Transform,
  Sprite,
  AutoMove,
  Spawner,
  GridTransform,
  EmitEvent,
  StartTimeline,
  Timeline,
  OnTimeline,
  OnEvent,
  TileMap,
  Translate,
  ForEachTransform,
  ParticleTransform,
  RandomMover,
  Destroy,
  Uuid,
  Target,
  SetProperties,
  Properties,
  ChangeProperties,
  LimitProperties,
  CollisionLayers,
  MoveHere,
  ConditionalTransform,
  StopMovement,
  TiledSprite,
  CreateEntity,
  FollowPath,
  AnimatedSprite,
  Goal,
  TapController,
  Jump,
  GravityAffected,
  Random,
  MoveTo,
  Move,
  SwipeController,
  KeyController,
  Shape,
  Cooldown,
  RandomChoose,
  Delay,
  SetGameState,
  CollisionWith,
  PressController,
  PlaySound,
  Multiple,
  MultiComponent,
  RestrictPosition,
  Tween,
  CreateToy,
  ScrollTransform,
  Camera,
  PhysicsBody2D,
  RemoveComponentFromToy,
  ApplyForce2D,
  ApplyImpulse2D,
  SetLinearVelocity2d,
  SetBodyProperties,
  Sequence,
  ChangeBodyType,
  ApplyJoint,
  RemoveJoints,
  SetState,
  PhysicsBody,
  SetCollisionFilter,
  CreateFeature,
  FromToy,
  PhysicsFixture,
  PhysicsAddFixture,
  TransformGraphCreate,
  CollisionBox,
  GameText,
  Repeater,
  GotoScene,
  GotoGame,
  StartScene,
  DelayTransform,
  RandomTransform,
  AllTransforms,
  PanController,
  Slot,
  SetTransformProperties,
  OnEventTransform,
  AskInput,
  Log,
  GiveScore,
  Leaderboard,
  Path,
  Circle,
  LuaScript,
  FetchTransform,
  FetchData,
  GroupTransform,
  StateManager,
  StateManagerFeature,
  SpineTransform,
  SpineControl,
  ParallaxTransform,
  Point,
  OnDestroy,
  SpriteMask,
  Video,
  Unparent,
  CameraFollows,
  PlayAnimation

}
}
export default Components;
